
import Vue from 'vue';
import YoutubeEmbedLite from '../../app/components/youtube-embed/YouTubeEmbedLite.vue';

export default Vue.extend({ components: { YoutubeEmbedLite } });
